import { render, staticRenderFns } from "./FeeOrgDetailReport.vue?vue&type=template&id=bf089126&"
import script from "./FeeOrgDetailReport.vue?vue&type=script&lang=js&"
export * from "./FeeOrgDetailReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports